import { type Command } from '@telespot/core';

export const GET_USER_ROLES = 'user:getRoles';

export interface GetUserRolesPayload {
  userId: string;
}

export interface RoleItem {
  id: string;
  name: string;
}

export class GetUserRoles implements Command<typeof GET_USER_ROLES, GetUserRolesPayload> {
  public readonly name = GET_USER_ROLES;
  constructor(public readonly details: Readonly<GetUserRolesPayload>) {}
}
